// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"674":"626f9c51","3612":"626f9c51","5028":"626f9c51"}[chunkId] + ".chunk.css";
};